// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2agJj","file":"styles_file__3r4Dj"};